'use strict';

/* global google */

let autocomplete;
let address1Field;
let address2Field;
let postalField;
let cityField;
let statesField;
var formFields = [];

/**
 * @param {element} countrycode - user selected country code
 */
function initAutocomplete(countrycode) {
    var isAddressAutocompleteEnabled = $('.isAddressAutocompleteEnabled').val();
    if (isAddressAutocompleteEnabled !== 'true') {
        return;
    }

    const isModalOpen = $('#deliveryCheckModal').is(':visible');
    const scope = isModalOpen ? '#deliveryCheckModal ' : '';
    address1Field = document.querySelector('#address1');
    address2Field = document.querySelector('#houseNo');
    postalField = document.querySelector('#postalCode');
    cityField = document.querySelector('#city');
    statesField = document.querySelector('#state');
    var country = countrycode.toLowerCase();
    if (countrycode !== 'IN') {
        formFields.push(address1Field, address2Field, postalField, cityField, statesField);
    } else {
        formFields.push(address1Field, address2Field, postalField);
    }

    // Create the autocomplete object, restricting the search predictions to
    // addresses in the US and Canada.
    // eslint-disable-next-line no-undef
    if (typeof google === 'object' && typeof google.maps === 'object' && address1Field) {
        // eslint-disable-next-line no-undef
        autocomplete = new google.maps.places.Autocomplete(address1Field, {
            componentRestrictions: { country: country },
            fields: ['address_components', 'geometry']
        });
        // address1Field.focus();
        // When the user selects an address from the drop-down, populate the
        // address fields in the form.
        // eslint-disable-next-line no-use-before-define
        autocomplete.addListener('place_changed', fillInAddress);
    }
    var $pincodeField = $(`${scope}#postalCode`);
    var place;
    $pincodeField.attr('placeholder', '');
    $(address1Field).attr('placeholder', '');
    if ($pincodeField.length > 0 && typeof google === 'object' && typeof google.maps === 'object') {
        var pincodeAutocomplete = new google.maps.places.Autocomplete($pincodeField[0], {
            componentRestrictions: { country: country },
            fields: ['address_components'],
            types: ['postal_code']
        });

        pincodeAutocomplete.addListener('place_changed', function () {
            place = pincodeAutocomplete.getPlace();
            var isValidPincode = false;

            // Loop through the address components to find the postal code
            if (place.address_components) {
                place.address_components.forEach(component => {
                    if (component.types.includes('postal_code')) {
                        $pincodeField.val(component.long_name.replace(/ /g, '')).trigger('change');
                        isValidPincode = true;
                    }
                });
            }

            if (!isValidPincode) {
                $pincodeField.val('');
            }
        });
        // Hide saved address section on pincode input
        $pincodeField.on('input', function () {
            $('.user-saved-address').addClass('d-none');
        });

        // Add/Remove class on focus in/out of pincode field
        $pincodeField.on('focusin', function () {
            $('.pac-container').addClass('location-capture');
            $('.pac-container').addClass('pincode-location-capture');
        }).on('focusout', function () {
            $('.pac-container').removeClass('location-capture');
            $('.user-saved-address').removeClass('d-none');
        });
    }
}

/**
 * @param {element} countrycode - user selected country code
 */
function initAutocompleteEdit() {
    var isAddressAutocompleteEnabled = $('.isAddressAutocompleteEnabled').val();
    if (isAddressAutocompleteEnabled !== 'true') {
        return;
    }

    let countrycode;
    var $isoCode = $('.contact-number-field .phone-code').find('option[selected]');
    var isoCode = $isoCode.attr('id');
    var selectedCountryCode = $(`.contact-number-field .phone-code option[id='${isoCode}'][selected]`);

    if (selectedCountryCode && selectedCountryCode.length > 0) {
        countrycode = selectedCountryCode.attr('iso-code');
    } else {
        countrycode = $(`.contact-number-field .phone-code option[id='${isoCode}']`).attr('iso-code');
    }

    if (!countrycode) {
        countrycode = $('.contact-phone .phone-code option[selected]').attr('iso-code');
    }

    initAutocomplete(countrycode);
}
/**
 * Description
 * - This function is used to fill the address fields in the form
 */
function fillInAddress() {
    let postcode = '';
    let cityLong = '';
    let stateLong = '';
    let stateShort = '';
    let countryLong = '';
    let countryShort = '';
    // Get the place details from the autocomplete object.
    const place = autocomplete.getPlace();
    let cityName;

    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    // place.address_components are google.maps.GeocoderAddressComponent objects
    // which are documented at http://goo.gle/3l5i5Mr
    // eslint-disable-next-line no-restricted-syntax
    for (const component of place.address_components) {
        // @ts-ignore remove once typings fixed
        const componentType = component.types[0];

        switch (componentType) {
            case 'administrative_area_level_1':
                stateLong = component.long_name;
                stateShort = component.short_name;
                $('#state').addClass('has-value');
                $('#state').parent().find('.error-message').addClass('d-none');
                $('#state').val(component.long_name);
                break;

            case 'locality':
                cityName = component.long_name;
                if (!cityName.toLowerCase().match(/^[0-9a-z]+$/)) {
                    cityName = '';
                }
                cityLong = cityName;
                $('#city').addClass('has-value');
                $('#city').parent().find('.error-message').addClass('d-none');
                $('#city').val(component.long_name);
                break;

            case 'country':
                countryShort = component.short_name;
                countryLong = component.long_name;
                break;

            case 'postal_code':
                postcode = component.long_name ? component.long_name.replace(/ /g, '') : '';
                break;
            default:
                break;
        }
    }

    let newAddress = address1Field.value;
    if (countryShort) {
        if (countryShort === 'IN') {
            if (postalField !== null) {
                postalField.value = postcode;
                $(`#${postalField.id}`).trigger('change');
                if (postalField) {
                    $('#postalCode').addClass('has-value');
                    $('#postalCode').parent().find('.error-message').addClass('d-none');
                } else {
                    $('#postalCode').removeClass('has-value');
                    $('#postalCode').parent().removeClass('error-class').find('.error-message')
                        .removeClass('d-none');
                }
            }
        } else {
            if (cityField !== null) {
                cityField.value = cityLong;
                if (cityLong) {
                    $('#city').addClass('has-value');
                    $('#city').blur();
                } else {
                    $('#city').removeClass('has-value');
                }
            }
            if (statesField !== null) {
                statesField.value = stateShort;
                if (stateShort) {
                    $('#state').addClass('has-value');
                } else {
                    $('#state').removeClass('has-value');
                }
            }
            if (postalField !== null) {
                postalField.value = postcode;
                if (postcode) {
                    $('#postalCode').addClass('has-value');
                } else {
                    $('#postalCode').removeClass('has-value');
                }
            }
            if ($(statesField).parent().find('li#' + stateShort).length !== 0) {
                $(statesField).parent().find('li#' + stateShort).click();
            }
        }
    } else if (postalField !== null) {
        postalField.value = '';
        $(`#${postalField.id}`).trigger('change');
    }

    newAddress = address1Field.value.replace(', ' + cityLong + ',', '').replace(stateLong + ',', '').replace(countryLong, '');
    // trim the last comma
    if (countryShort && countryShort !== 'IN') {
        newAddress = newAddress.replaceAll(',', '');
    }
    newAddress = newAddress.replace(/,\s*$/, '');
    address1Field.value = newAddress.trim();
    $('#address1').blur();
    // After filling the form with address components from the Autocomplete
    // prediction, set cursor focus on the second address line to encourage
    // entry of subpremise information such as apartment, unit, or floor number.

    for (let i = 0; i < formFields.length; i += 1) {
        var formField = formFields[i];
        if (formField && !formField.value) {
            formField.focus();
            break;
        }
    }
}
window.initAutocomplete = initAutocompleteEdit;

$(document).ready(function () {
    const googleScriptUrl = $('.googleMapURL').val();

    if (googleScriptUrl && !window.googleMapsScriptAdded) {
        const script = document.createElement('script');
        script.src = googleScriptUrl;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
        window.googleMapsScriptAdded = true;
    }
});

/**
 * Toggle the hide-scroll-suggestions class on scroll-container-div based on the visibility of any pac-container.
 *
 * This function is used to hide the scroll bar when any pac-container (i.e. suggestions from Google Autocomplete) is visible
 * and show the scroll bar when there are no visible pac-containers. It is used in the MutationObserver below.
 */
function toggleScrollSuggestionClass() {
    if ($('.pac-container:visible').length > 0) {
        $('.scroll-container-div').addClass('hide-scroll-suggestions');
    } else {
        $('.scroll-container-div').removeClass('hide-scroll-suggestions');
    }
}

$(document).ready(function () {
    var isdCodesJSON = $('#isdCodes').attr('data-value');
    var code = isdCodesJSON ? JSON.parse(isdCodesJSON) : '';
    if (code) {
        $(document).on('change', '#country', function () {
            var con = $('input[name$=shippingAddressCountryCodeValue]').val();
            $('.isd-code').val(code[con]);
        });
    }

    // Initial check
    toggleScrollSuggestionClass();

    // MutationObserver to watch for changes in the pac-container visibility
    const observer = new MutationObserver(toggleScrollSuggestionClass);

    observer.observe(document.body, { attributes: true, childList: true, subtree: true });
});

module.exports = {
    initAutocomplete: initAutocomplete
};
